"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SPPInvoiceSubmission = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.SPPInvoiceSubmission = typebox_1.Type.Object({
    first_name: typebox_1.Type.String(),
    orders: typebox_1.Type.Array(typebox_1.Type.Object({ order_number: typebox_1.Type.String(), address: typebox_1.Type.String(), final_notice: typebox_1.Type.Boolean() })),
    wayste_active: typebox_1.Type.Boolean(),
    hauler_id: typebox_1.Type.String(),
    url_button_path: typebox_1.Type.String(),
    final_notice: typebox_1.Type.Boolean(),
});
//# sourceMappingURL=spp-invoice-submission.js.map